import { WppSpinner } from '@wppopen/components-library-react'
import styles from './LoadingSpinner.module.scss'

interface LoadingSpinnerProps {
  dataTestId?: string
}

function LoadingSpinner({ dataTestId = 'loading-spinner' }: LoadingSpinnerProps) {
  return <WppSpinner size="l" className={styles.loadingSpinner} data-testid={dataTestId} />
}

export default LoadingSpinner
